import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { DurationInMinutes } from "@@/shared/date-time/time-spans";
import { idZodSchema } from "@@/shared/id";
import { addressZodSchema } from "@@/shared/locations/address";
import { phoneZodSchema } from "@@/shared/phone";
import { storageItemIdZodSchema } from "@@/shared/storage-items/storage-item-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { weeklyScheduleZodSchema } from "../../weekly-schedules/weekly-schedule";

const createProviderCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("CREATE_PROVIDER_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    name: z.string(),
    subtitle: z.string(),
    description: z.string().optional(),
    publicEmail: z.string().email(),
    orderEmail: z.string().email(),
    prepTime: z
        .number()
        .min(0)
        .int() as unknown as z.ZodType<DurationInMinutes>,
    publicPhone: phoneZodSchema.optional(),
    orderPhone: phoneZodSchema,
    address: addressZodSchema,
    businessHours: weeklyScheduleZodSchema,
    logoImage: storageItemIdZodSchema,
    posterImage: storageItemIdZodSchema,
});

type CreateProviderCommand = z.infer<typeof createProviderCommandZodObject>;

type FactoryParams = Except<
    CreateProviderCommand,
    "_id" | "_type" | "_createdAt"
>;
const createProviderCommandFactory = (
    params: FactoryParams,
): CreateProviderCommand => {
    const command = {
        ...params,
        _id: generateId({ prefix: "create-provider__" }),
        _type: "CREATE_PROVIDER_COMMAND" as const,
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export { createProviderCommandFactory, createProviderCommandZodObject };
export type { CreateProviderCommand };
